var GrayContentPanelType3 = (function () {
  
  
  var $allContentType3Panels = $('section.rzf-gry.rzf-gry-content-panel-type-3');
  
  var debounce;
  
  function init() {
    cloneCaptionDiv();
  }
  
  function cloneCaptionDiv() {
      
    $allContentType3Panels.each(function (i, el) {
      // $(el).prepend($div2).prepend($div1);
      var $innerCaptionDiv = $('.caption', $(el));
      
      if ($innerCaptionDiv.length > 0) {
        $innerCaptionDiv.addClass('inner-caption');
        
        var $outerCaptionDiv = $(document.createElement('div'));
        $outerCaptionDiv.addClass('caption outer-caption')
          .html($innerCaptionDiv.html());
        
        var $contentPanelDiv = $('div.rzf-gry-content-panel-type-3', $(el));
        $contentPanelDiv.prepend($outerCaptionDiv);
      }
      
      // Add color theme to controls, if controls are present.
      var $controls = $('.rzf-gry-controls', $(el));
      if ($controls.length > 0) {
        var theme = $('div.rzf-gry-content-panel-type-3', $(el)).data('rzf-gry-arrow-skin') + '-theme';
        $controls.addClass(theme);
      }
    });
  }
  
  return {
    init: init,
  };
  
}());
